export default __webpack_public_path__ + "static/media/official-ball.63880cd8.png";